/* global Word */

const POLL_INTERVAL_MS = 500;
const DEFAULT_TIMEOUT_MS = 30000;

// document.save() + context.sync() only confirms Word accepted the save locally. The server copies the
// file from SharePoint, so it must not run until Word has finished saving (AutoSave upload included),
// otherwise the copy misses the user's latest edits. Resolves true when saved, false on timeout. Callers
// that replace content or close the document must stop or fall back safely on false.
export async function saveDocumentAndWait(timeoutMs = DEFAULT_TIMEOUT_MS) {
  await Word.run(async (context) => {
    context.document.save();
    await context.sync();
  });

  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    const saved = await Word.run(async (context) => {
      context.document.load("saved");
      await context.sync();
      return context.document.saved;
    });
    if (saved) return true;
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
  }
  return false;
}
